export default __webpack_public_path__ + "static/media/talent-main-section-article2-flexera-header-Dev-IT.860909a9.svg";